import axios from "axios";
import { JSON_URL } from "../../config/RouterLink";

//------------- STATE -------------------------
const initialState = {
    banderaHomeModal: null,
    imageHomeModal:'',
    /* Error */
    messageError: ''
}
//------------- TYPES -------------------------
/* Gets */
const GET_BANDERA_HOME_MODAL = "GET_BANDERA_HOME_MODAL";
const GET_IMAGE_HOME_MODAL = "GET_IMAGE_HOME_MODAL";
/* Errors Service */
const SERVICIO_HOME_MODAL_ERROR = 'SERVICIO_HOME_MODAL_ERROR';
const SERVICIO_HOME_MODAL_OFFLINE = 'SERVICIO_HOME_MODAL_OFFLINE';
//------------- REDUCER -------------------------

export default function HomeModalReducer (state = initialState, action){
    switch (action.type) {
        /* GET */
        case GET_BANDERA_HOME_MODAL:
            return {
                ...state,
                banderaHomeModal: action.payload.valorConfig
            }
        case GET_IMAGE_HOME_MODAL:
            return {
                ...state,
                imageHomeModal: action.payload.valorConfig
            }
        /* Errors Service */
        case SERVICIO_HOME_MODAL_ERROR:
            return {
                ...state,
                messageError: action.payload,
            }
        case SERVICIO_HOME_MODAL_OFFLINE:
            return {
                ...state,
                messageError: "El sistema se encuentra fuera de servicio, favor de acceder más tarde.",
            };
        default:
        return state;
    }
}; 

//------------- GETS -------------------------
export const getBanderaHomeModal = () => async (dispatch, getState) => {
    const { data } = await axios(window.location.origin + JSON_URL);
    axios({
        url: `${data.urlServer}/ConcursoPublico/api/catalogo/parametro/general`,
        method: 'POST',
        data: {
            "idValor": 57
        },
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + getState().usuarioLogin.accessToken
        }
    })
    .then(function (res) {
        dispatch({type: GET_BANDERA_HOME_MODAL, payload: res.data});
    })
    .catch((err) => {
        if (err.response === undefined) {
            dispatch({ type: SERVICIO_HOME_MODAL_OFFLINE });
        } else {
           /*  Error con cualquier status de error */
            if (err.response.status !== '') {
                dispatch({
                    type: SERVICIO_HOME_MODAL_ERROR,
                    payload: err.response.statusText
                });
            }
        }
    });
}

export const getImageHomeModal = () => async (dispatch, getState) => {
    const { data } = await axios(window.location.origin + JSON_URL);
    axios({
        url: `${data.urlServer}/ConcursoPublico/api/catalogo/parametro/obtenerArchivoGluster`,
        method: 'POST',
        data: {
            "idValor": 58
        },
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + getState().usuarioLogin.accessToken
        }
    })
    .then(function (res) {
        dispatch({type: GET_IMAGE_HOME_MODAL, payload: res.data});
    })
    .catch((err) => {
        if (err.response === undefined) {
            dispatch({ type: SERVICIO_HOME_MODAL_OFFLINE });
        } else {
           /*  Error con cualquier status de error */
            if (err.response.status !== '') {
                dispatch({
                    type: SERVICIO_HOME_MODAL_ERROR,
                    payload: err.response.statusText
                });
            }
        }
    });
}